export const INIT_NO_OP_NUM = -1;
export const CDA_FILE_TYPE = 'CDA';
export const PDF_FILE_TYPE = 'PDF';
export const REPORT_FILE_TYPE = 'REPORT';
export const CDA_ROUTE_NAME = 'cdaContent';
export const DEVICE_CSV_FILE_TYPE = 'DEVICE DATA FILE';

// in php.ini: session.gc_maxlifetime = 1440 # seconds + 10 extra second for session to be timed out
export const SESSION_TIME = 1440*3000+10*3000; 
export const PDF_ROUTE_NAME = 'pdfContent';

export const FEATURES = {
	cda_header_providers : true
};

